import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";

const WelcomeModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm transition-opacity">
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden transform transition-all">
        {/* Header */}
        <div className="bg-gradient-to-r from-primary to-primary-varients-700 p-6 text-white text-center relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors">
            <FontAwesomeIcon icon={faTimes} size="lg" />
          </button>
          <div className="text-5xl mb-2 animate-bounce">🎉</div>
          <h2 className="text-3xl font-bold mb-1">Welcome Aboard!</h2>
          <p className="text-white/90 font-medium">
            Your 7-Day Free Trial Starts Now
          </p>
        </div>

        {/* Content */}
        <div className="p-8">
          <p className="text-gray-600 text-center mb-6">
            You've just unlocked full access to our premium suite of tools.
            Here's what you get:
          </p>

          <ul className="space-y-3 mb-8">
            {[
              "AI-Powered Google Review Generator",
              "Advanced SEO Optimization Tools",
              "Complete Mini Website for your Business",
            ].map((item, index) => (
              <li key={index} className="flex items-start gap-3 text-gray-700">
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  className="text-primary mt-1"
                />
                <span className="font-medium">{item}</span>
              </li>
            ))}
          </ul>

          <div className="bg-primary-varients-50 border border-primary-varients-200 rounded-xl p-4 mb-6 text-center">
            <p className="text-sm text-dark">
              After your 7 days are up, simply contact us to extend your
              subscription in minutes!
            </p>
          </div>

          <button
            onClick={onClose}
            className="w-full bg-gradient-to-r from-primary to-primary-varients-700 text-white font-bold py-3.5 rounded-xl shadow-lg hover:shadow-xl hover:opacity-95 transition-all transform hover:-translate-y-0.5">
            Let's Get Started
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
